import React, { ReactElement } from "react";
import { Checkbox } from "@components/form";
import { useState } from "@helpers/Store";
import * as Type from "@interface/index";
import * as Middleware from "@middlewares/index";

interface IProps {
  currentStep: number;
  maxStep: number;
  setCurrentStep: (value: number) => void;
  companySpecializationsList: number[];
  networkingProfile: {
    interestCompanyTypes: number[];
    languages: number[];
    directions: number[];
    specializations: number[];
    about: string;
  };
  required?: boolean;
  updateNetworkingProfile: any;
}

const RegStep4 = ({
  currentStep,
  maxStep,
  setCurrentStep,
  companySpecializationsList,
  networkingProfile,
  required,
  updateNetworkingProfile,
}: IProps): ReactElement => {
  const onCheckHandler = (
    event: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ): void => {
    if (networkingProfile?.specializations?.includes(+event.target.value)) {
      networkingProfile?.specializations?.splice(
        networkingProfile?.specializations?.indexOf(+event.target.value),
        1
      );
    } else {
      networkingProfile?.specializations?.push(+event.target.value);
    }
  };

  const onSubmitHandler = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (networkingProfile?.specializations?.length > 0) {
      updateNetworkingProfile(networkingProfile);
    } else if (!required) {
      setCurrentStep(currentStep + 1);
    } else {
      let ProgressAlert: any;
      await Middleware.Ui.Alert.open("Process", {
        text: "Выберите хотя бы одно значение",
        component: (c: any) => {
          ProgressAlert = c;
        },
      });
      ProgressAlert.setStatus("danger");
      ProgressAlert.startTimer();
    }
  };

  return (
    <>
      <section className="cabinet__block">
        <form onSubmit={onSubmitHandler} className="profile-netw-step">
          <div className="profile-netw-step__header">
            <span> Шаг {currentStep}</span> / {maxStep}
          </div>
          <div className="profile-netw-step__body">
            <div className="profile-netw-step__body-header">
              <p className="profile-netw-step__title">
                {required ? <span>* </span> : <></>}
                <span>Для сотрудников ТА и ТО:</span> На каких видах туризма вы
                специализируетесь?
              </p>
              <p className="profile-netw-step__required">
                {required
                  ? "Обязательный пункт"
                  : "Вы можете заполнить этот пункт потом"}
              </p>
            </div>

            <p className="profile-netw-step__desc profile-netw-step__desc--small">
              Отметьте один или несколько пунктов, если данные виды туризма
              занимают существенную долю в ваших продажах.{" "}
            </p>
            <div className="profile-netw-step__main profile-netw-step__main--checkbox-list">
              {companySpecializationsList?.map((Item: any, index: number) => {
                return (
                  <Checkbox
                    key={index}
                    name="languages"
                    type="profile"
                    placeholder={Item.name}
                    value={Item.id}
                    hiddenInput
                    checked={networkingProfile?.specializations?.includes(
                      Item.id
                    )}
                    onChange={onCheckHandler}
                  />
                );
              })}
            </div>
          </div>

          <div className="profile-netw-step__footer">
            <button type="submit" className="btn btn--red">
              Дальше
            </button>
            {required ? (
              <></>
            ) : (
              <button
                className="btn btn--transparent"
                onClick={() => {
                  setCurrentStep(currentStep + 1);
                }}
              >
                Пропустить
              </button>
            )}
          </div>
        </form>
      </section>
    </>
  );
};

export default RegStep4;
